import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable} from 'rxjs';
import { AuthService } from '../modulos/auth/services/auth.service';
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {          
    this.store.select("usuarioApp").subscribe((resp)=>{
        if(resp.currentUser){          
          return this.router.navigate(['admin/dashboard']);;            
        }else{
          return true;
        }
      })
      return true;    
  }
}